module.exports = __webpack_public_path__ + "static/media/sticker.8e62e3dd.png";